"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6758],{

/***/ 66758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15072);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34892);
/* harmony import */ var src_utils_devices__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97348);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  .tags-item {\n    display: flex;\n    width: fit-content;\n    background-color: var(--quaternary-color);\n    padding: 5px 10px;\n    color: var(--primary-gray);\n    font-size: 16pt;\n    :hover {\n      background-color: #dde5f4;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function WidgetTags(param) {
    var id = param.id, tags = param.tags;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var responsive = (0,src_utils_devices__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WidgetWrapper, {
        id: id,
        style: {
            filter: src_constants__WEBPACK_IMPORTED_MODULE_3__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : ""
        },
        children: tags === null || tags === void 0 ? void 0 : tags.map(function(item, index) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                className: "tags-item",
                href: "/tags/".concat(item),
                //! DATALAYER
                onClick: function() {
                    return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__/* .sendDataLayerGlobal */ .dE)({
                        type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                        router: router === null || router === void 0 ? void 0 : router.pathname,
                        section: "แท็กที่เกี่ยวข้อง",
                        position: !(responsive === null || responsive === void 0 ? void 0 : responsive.isMobile) ? "ใต้:เนื้อหาที่-3" : "ใต้:ข่าวที่เกี่ยวข้อง",
                        data: {
                            block: "1",
                            title: item,
                            heading: "แท็กที่เกี่ยวข้อง",
                            index: index + 1
                        }
                    });
                },
                children: item
            }, index);
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (WidgetTags);
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div(_templateObject());


/***/ })

}]);